import Colors from '../../../config/Colors';
import Layout from '../../../config/Layout';

export default {
    tabBar: {
        backgroundColor: Colors.primary
    },
    tabBarContent: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: Colors.darkTransparent
    },
    tabItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        width: '100%',
        marginBottom: 2,
        paddingVertical: Layout.isDesktop ? Layout.gutterBig : Layout.gutter
    },

    itemLogo: {
        display: 'flex',
        alignItems: 'center'
    },

    logo: {
        width: 40,
        height: 40
    },

    itemAtivo: {
        color: Colors.warning
    },

    itemInativo: {
        color: Colors.primary
    },

    itemButtonAtivo: {
        padding: 14,
        borderRadius: 100,
        backgroundColor: Colors.lighter
    }
};
